"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateStringToObject = void 0;
const _ = require("lodash");
const moment = require("moment");
const padNumber_1 = require("./padNumber");
const getApplicableDateSegments_1 = require("./getApplicableDateSegments");
const dateStringMatchesFormatString_1 = require("./dateStringMatchesFormatString");
const dateStringToObject = (dateString, formatString) => {
    const haveValue = _.isString(dateString) && dateString.length;
    const isValid = haveValue && (0, dateStringMatchesFormatString_1.dateStringMatchesFormatString)(dateString, formatString);
    if (!isValid) {
        return {
            year: "",
            month: "",
            day: ""
        };
    }
    // determine which parts of the date we need
    const dateSegments = (0, getApplicableDateSegments_1.getApplicableDateSegments)(formatString);
    const momentDate = moment(dateString, formatString, true);
    return {
        year: dateSegments.year ? momentDate.year().toString() : "",
        month: dateSegments.month ? (0, padNumber_1.padNumber)(momentDate.month() + 1) : "",
        day: dateSegments.day ? (0, padNumber_1.padNumber)(momentDate.date()) : ""
    };
};
exports.dateStringToObject = dateStringToObject;
//# sourceMappingURL=dateStringToObject.js.map